import {lightTheme} from "../constant/Constant";
import {alpha} from "@mui/material/styles";

import {
  outlinedInputClasses,
  menuItemClasses,
  iconButtonClasses,
  dialogClasses,
  drawerClasses,
  autocompleteClasses,
  formControlClasses,
  dialogActionsClasses,
  buttonClasses
} from "@mui/material";
import {red} from "@mui/material/colors";

const components = theme => {
  const {
    shadows
  } = theme;
  const {
    error,
    divider,
    action,
    grey,
    primary,
    text,
    success
  } = theme.palette;
  return {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          fontFamily: "Urbanist!important",
        }
      }
    },
    // MuiCssBaseline: {
    //   styleOverrides: {
    //     "*": {
    //       margin: 0,
    //       padding: 0,
    //       boxSizing: "border-box"
    //     },
    //     html: {
    //       width: "100%",
    //       height: "100%",
    //       WebkitOverflowScrolling: "touch",
    //       MozOsxFontSmoothing: "grayscale",
    //       WebkitFontSmoothing: "antialiased"
    //     },
    //     body: {
    //       width: "100%",
    //       height: "100%"
    //     },
    //     a: {
    //       textDecoration: "none",
    //       color: primary.main
    //     },
    //     input: {
    //       "&[type=number]": {
    //         MozAppearance: "textfield",
    //         "&::-webkit-outer-spin-button": {
    //           margin: 0,
    //           WebkitAppearance: "none"
    //         },
    //         "&::-webkit-inner-spin-button": {
    //           margin: 0,
    //           WebkitAppearance: "none"
    //         }
    //       }
    //     },
    //     "#root": {
    //       width: "100%",
    //       height: "100%"
    //     },
    //     "#nprogress .bar": {
    //       zIndex: "2000 !important",
    //       backgroundColor: primary.main
    //     }
    //   }
    // },
    MuiAvatar: {
      styleOverrides: {
        fallback: {
          height: "75%",
          width: "75%"
        }
      }
    },
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       textTransform: "none",
    //       borderRadius: "2px",
    //       color: "inherit",
    //       boxShadow: "none",
    //       padding: "0.6rem 1.5rem",
    //       fontSize: 12,
    //       fontWeight: 600,
    //       minWidth: 84,
    //
    //       "&.MuiButton-root": {
    //         borderRadius: '2px',
    //         backgroundColor: text.primary,
    //         "&.MuiButton-outlined": {
    //           backgroundColor: 'transparent',
    //         }
    //       },
    //
    //       "&.Mui-disabled": {
    //         backgroundColor: alpha(text.primary, 0.3),
    //         // opacity:0.6,
    //         color: text.disabled
    //       },
    //       "&.MuiButton-containedError": {
    //         backgroundColor: error.main,
    //         color: "white",
    //         boxShadow: "none"
    //       },
    //       "&.MuiButton-containedSuccess": {
    //         color: "white",
    //         "&:hover": {
    //           boxShadow: "none",
    //           backgroundColor: success.main
    //         }
    //       },
    //       "& .MuiButton-startIcon .MuiSvgIcon-root": {
    //         fontSize: 16
    //       }
    //     },
    //     outlinedPrimary: {
    //       borderColor: theme.palette.borderColor.one, //divider,
    //       color: text.primary
    //     },
    //     containedPrimary: {
    //       color: "white",
    //       "&:hover": {
    //         // boxShadow: "none"
    //       }
    //     }
    //   },
    //   variants: [{
    //     props: {
    //       variant: "GreyOutlined"
    //     },
    //     style: {
    //       // border: `1px solid ${divider}`,
    //       color: theme => lightTheme(theme) ? text.primary : "#fff",
    //       "&:hover": {
    //         backgroundColor: "transparent"
    //       }
    //     }
    //   }, {
    //     props: {
    //       variant: "GreyOutlined",
    //       size: "small"
    //     },
    //     style: {
    //       padding: "0.3rem 0.8rem"
    //     }
    //   }, {
    //     props: {
    //       variant: "text"
    //     },
    //     style: {
    //       padding: 0,
    //       "&:hover": {
    //         backgroundColor: "transparent"
    //       }
    //     }
    //   }, {
    //     props: {
    //       variant: "white"
    //     },
    //     style: {
    //       padding: "12px 24px",
    //       backgroundColor: "white",
    //       color: text.disabled
    //     }
    //   }, {
    //     props: {
    //       variant: "dashed"
    //     },
    //     style: {
    //       height: 36,
    //       padding: 0,
    //       minWidth: 36,
    //       maxWidth: 36,
    //       display: "flex",
    //       alignItems: "center",
    //       justifyContent: "center",
    //       border: `1px dashed ${divider}`,
    //       borderRadius: "50%",
    //       overflow: "hidden"
    //     }
    //   }]
    // },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {
          variant: "h6"
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          // boxShadow: 'none',
          boxShadow: shadows[1],
          // border: "1px solid #E5EAF2",
          borderRadius: 8,
          variants: [
            {
              props: {variant: 'outlined'},
              style: {
                borderColor: theme.palette.borderColor.other1,
              },
            },
          ],
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "auto",
          marginRight: "16px"
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: `${theme.palette.background.default}`,
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
          boxShadow: "none"
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: 0,
          minHeight: 0,
          "&.Mui-expanded": {
            minHeight: "auto"
          },
          ".MuiAccordionSummary-content": {
            margin: 0
          },
          ".MuiAccordionSummary-content.Mui-expanded": {
            margin: 0
          }
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }
    },
    MuiRating: {
      styleOverrides: {
        root: {
          color: "#FFD600"
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          borderColor: "transparent"
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.Mui-selected:hover": {
            backgroundColor: "transparent"
          }
        }
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& .MuiTableRow-root:last-of-type": {
            "& .MuiTableCell-root": {
              borderBottom: 0
            }
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: 13,
          fontWeight: 500,
          borderBottom: 0,
          "&:first-of-type": {
            // paddingLeft: 0
          },
          "&:last-of-type": {
            // paddingRight: 0
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: text.secondary,
          textTransform: "none",
          fontSize: 12,
          fontWeight: 500,
          padding: 0,
          minWidth: "auto",
          marginLeft: "1rem",
          marginRight: "1rem",
          paddingLeft: 8,
          paddingRight: 8
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          "& .MuiButtonBase-root:first-of-type": {
            marginLeft: 0
          },
          "& .MuiButtonBase-root:last-of-type": {
            marginRight: 0
          }
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          "& .MuiPopover-paper": {
            // boxShadow: shadows[1],
            borderRadius: 4,
            backgroundColor: theme.palette.background.paper,
          }
        }
      }
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          // fontFamily: "'Montserrat', sans-serif",
          fontFamily: "Urbanist!important",
          boxShadow: "none!important"
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 7,
          borderRadius: 14,
          backgroundColor: primary[100]
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          backgroundColor: grey[200]
        },
        track: {
          opacity: 1,
          backgroundColor: action.disabledBackground
        },
        switchBase: {
          "&.Mui-checked .MuiSwitch-thumb": {
            color: "#2499EF !important",
            backgroundColor: primary.main
          }
        }
      }
    },
    // MuiInputBase: {
    //   styleOverrides: {
    //     input: {
    //       "&::placeholder": {
    //         // opacity: 0.86,
    //         color: theme.palette.text.secondary
    //       }
    //     },
    //     focused:{
    //       outline: "none"
    //     },
    //     root:{
    //       '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    //         border: `1px solid ${theme.palette.text.secondary} !important`,
    //         // borderColor: `${theme.palette.text.secondary} !important`, // 移除焦点时的边框
    //       },
    //       '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    //         border: `1px solid ${theme.palette.text.secondary} !important`,
    //         // borderColor: `${theme.palette.text.secondary} !important`, // 移除焦点时的边框
    //       },
    //     }
    //   }
    // },
    MuiFormControl: {
      styleOverrides: {
        root: {
          [`&.Mui-error`]: {
            backgroundColor: red[500]
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          padding: 0,
          "& .MuiInputBase-root": {
            "& .MuiInputBase-input": {
              height: '100%', //"24px",
              padding: "15px 16px",
              fontFamily: "Urbanist",
            },
            "& fieldset": {
              // 自定义边框样式
              // height: '100%',
              // top: 0,
              border: `0.5px solid`,
              borderColor: text.tertiary,
              outline: "none",
              borderRadius: "0px",
            },
            "&:hover": {
              "& .MuiInputAdornment-root .clearIcon": {
                opacity: 1,
                visibility: "visible",
              },
              // 自定义悬停状态下的边框样式
              "& fieldset": {
                border: `0.5px solid ${text.tertiary}`,
              },
            },
            "&.Mui-focused fieldset": {
              // 自定义聚焦状态下的边框样式
              outline: "none",
              border: `1.5px solid ${text.primary}`,
            },
            "& .MuiInputAdornment-root .clearIcon": {
              opacity: 0,
              visibility: "hidden",
            },
          },

          "& .MuiOutlinedInput-root": {
            paddingLeft:0,
            // paddingRight:0,
          },

          "& .MuiInputBase-root .MuiInputBase-root-MuiOutlinedInput-root": {
            paddingRight: 0,
            paddingLeft: 0,
          },
          "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
            paddingTop: "0px",
            paddingBottom: "0px",
            // paddingRight: "8px",
            "& .MuiAutocomplete-input": {
              paddingTop: "4px",
              paddingBottom: "4px",
            },
          },
          "& .MuiInputBase-sizeSmall": {
            "& .MuiInputBase-inputSizeSmall": {
              padding: "4px 16px",
              fontSize: "12px",
            },
            "& fieldset": {
              // 自定义边框样式
              outline: "none",
              borderRadius: "0px",
            },
          },
          "& .Mui-error": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: `${alpha(text.disabled, 0.2)}!important`,
            },
          },
          "& .MuiInputBase-input": {
            fontSize: "16px",
          },
          "& .MuiInputBase-input::placeholder": {
            fontSize: "16px",
          },
          "& .MuiFormHelperText-root": {
            // color: `${error.main}!important`,
            fontSize: "12px",
            position: "absolute",
            bottom: "-20px",
          },
        },
      },
      // variants: [{
      //   props: {
      //     variant: "outlined",
      //     // color: "grey"
      //   },
      //   style: {
      //     "& .MuiInputBase-root": {
      //       "& .MuiInputBase-input": {
      //         borderRadius: "0px!important",
      //       }
      //     },
      //     "& .MuiOutlinedInput-input": {
      //       fontSize: theme.typography.pxToRem(16),
      //       fontWeight: 500,
      //     },
      //     "& .MuiOutlinedInput-notchedOutline": {
      //       border: `1px solid ${theme.palette.text.secondary}`
      //     },
      //     '& .MuiOutlinedInput-root:focus .MuiOutlinedInput-notchedOutline': {
      //       border: `1px solid ${theme.palette.text.primary} !important`,
      //       // borderColor: `${theme.palette.text.secondary} !important`, // 移除焦点时的边框
      //     },
      //     "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      //       border: `1px solid ${theme.palette.text.primary} !important`
      //     },
      //     "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      //       border: `1px solid ${theme.palette.text.primary} !important`
      //     },
      //     "& input::placeholder": {
      //       color: theme.palette.text.primary,
      //       fontWeight: 400,
      //     },
      //     [`& .${outlinedInputClasses.error}`]: {
      //       "& .MuiOutlinedInput-notchedOutline": {
      //         backgroundColor: alpha(error.main, 0.1)
      //       },
      //     },
      //     [`& .${outlinedInputClasses.error}:hover`]: {
      //       "& .MuiOutlinedInput-notchedOutline": {
      //         border: `1px solid ${error.main} !important`
      //       },
      //     },
      //   }
      // }]
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          "& .secondary": {
            opacity: 0.4
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          variants: [
            {
              props: {variant: 'outlined'},
              style: {
                textTransform: "none",
                borderColor: theme.palette.borderColor.one,
              },
            },
            {
              props: {variant: 'outlinedReverse'},
              style: {
                textTransform: 'none',
                backgroundColor: `${theme.palette.background.default} !important`,
                color: theme.palette.background.default
              },
            },
          ],
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.card,
          color : theme.palette.text.primary,
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: theme.palette.text.secondary,
        },
        root: {
          [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: theme.palette.text.primary,
          },
          [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
            borderWidth: 1,
            borderColor: theme.palette.text.primary
          },
        },
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          [`&.${menuItemClasses.selected}`]: {
            backgroundColor: theme.palette.background.other1,
            borderRadius: '4px',
            padding: '8px'
          }
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          [`& .${dialogClasses.paper}`]: {
            // borderRadius: '4px',
            backgroundImage: 'none'
          }
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          [`& .${drawerClasses.paper}`]: {
            // borderRadius: '16px',
            backgroundImage: 'none',
            backgroundColor: theme.palette.background.default
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          [`& .${autocompleteClasses.inputRoot}`]: {
            paddingTop: 0,
            paddingBottom: 0
          }
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Urbanist',
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          justifyContent: 'center',
          [`& > .${buttonClasses.root}`]: {
            flex: 1,
          }
        }

      }
    }
  };
};

const MuiButtonOverides = {
  MuiButton: {
    styleOverrides: {
      root: {
        variants: [
          {
            props: {variant: 'outlined'},
            style: {
              borderColor: `4px solid ${'red'}`,
            },
          },
        ],
      },
    },
  },
}


export default components;